import {IDffSegmentValues} from 'shared/types/lookups';
import {
    TDescriptiveFlexFieldData,
    TDescriptiveFlexfieldSegmentMinimizedEntity,
} from 'store/slices/descriptive-flexfields-slice/descriptive-flexfields-slice-types';

import {TFlexFieldInitValues} from './document-card-modal-types';

interface IConvertAdditionalFieldsTabValuesArgs {
    values: Record<string, string>;
}

export const convertAdditionalFieldsTabValues = (
    {values}: IConvertAdditionalFieldsTabValuesArgs,
): TDescriptiveFlexfieldSegmentMinimizedEntity => {
    const additionalFieldsConverted: TDescriptiveFlexfieldSegmentMinimizedEntity = {};

    Object
        .entries(values)
        .forEach(([key, value]) => {
            additionalFieldsConverted[key] = {
                segmentColumnName: key,
                segmentValue: value,
            };
        });

    return additionalFieldsConverted;
};

export const transformDtoToFlexFieldInitValues = (
    flexFieldDataDto: TDescriptiveFlexFieldData,
): TFlexFieldInitValues => Object.keys(flexFieldDataDto).reduce((acc, key) => {
    const segment = flexFieldDataDto[key];
    acc[segment.segmentColumnName] = segment.segmentValue;
    return acc;
}, {} as TFlexFieldInitValues);

export const transformSegmentToInitialValues = (dffSegmentValues: IDffSegmentValues | null | undefined) => {
    if (dffSegmentValues === null || dffSegmentValues === undefined) return null;
    return Object.keys(dffSegmentValues).reduce((acc: { [key: string]: string | null }, key: string) => {
        const segment = dffSegmentValues[key];
        acc[segment.segmentColumnName] = segment.segmentValue;
        return acc;
    }, {});
};
